"use client";
import { usePathname } from "next/navigation";
import { useEffect, Suspense } from "react";
import GoogleAnalytics from "./GoogleAnalytics";
// import { FacebookPixel } from "@/lib/facebook-pixel";

export function TrackingProvider() {
  const pathname = usePathname();

  useEffect(() => {
    // FacebookPixel.trackPageView();
  }, [pathname]);

  return (
    <Suspense fallback={null}>
      <GoogleAnalytics />
    </Suspense>
  );
}
